export const EVENTS_PAGE_TAB = 'events';
export const VIDEO_LIBRARY_PAGE_TAB = 'video-library';
export const TEAM_PAGE_TAB = 'team';
export const SETTINGS_TAB = 'settings';
export const BILLING_PAGE_TAB = 'billing-page';
export const APP_SUMO_PAGE = 'appsumo-plans';
export const GETTING_STARTED_TAB = 'getting-started';
export const ONBOARDING_PAGE_TAB = 'onboarding';
export const HELP_PAGE_TAB = 'help';
